import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';

import 'isomorphic-fetch';
import { polyfill } from 'es6-promise';
import {
	OFLC_RESEND_INVITATION,
	resendInvitationSuccess,
	resendInvitationFail
} from '../actions/action_resendInvitation';
import util from '../../../global/utils/Helpers';
polyfill();

let apiIndex = util.isLocalhost() ? 'http://localhost:9393/auth/graphql' : `${util.getCurrentHost()}/auth/auth/graphql`;
const getQuery = (data) => {
	//debugger;
	return JSON.stringify({
		query: `mutation {
			resubmitInvitation(
				group_id:"${data.currentUser.Group.id}",
				sender_subject_id:"${data.currentUser.subject}",
				email:"${data.props.recipientEmail}",
			)
		  }`
	});
};
const resendInvitationEpic = (action$) =>
	action$.pipe(
		ofType(OFLC_RESEND_INVITATION),
		mergeMap((action) =>
			fetch(apiIndex, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: getQuery(action.payload)
			})
				.then((response) => response.json())
				.then((data) => resendInvitationSuccess(data))
				.catch((error) => resendInvitationFail(true))
		)
	);

export default resendInvitationEpic;
